export const frontPageJs = () => {

	let areWeOnTheFrontPage = document.querySelector('#js__body.home');

	if(areWeOnTheFrontPage){


		

	}
	

}